<template>
  <div class="wt-custom-overlay-field wt2-sg">
    <component
      :is="componentName"
      :field="field"
      :fieldDataModel="fieldDataModel"
      :stage-rect="stageRect"
      :allowStoryboardingControls="false"
      @change="onValueChange"
    >
      <i
        v-if="field.tooltip"
        slot="tooltip"
        ref="tooltip"
        v-tooltip.extend="{
          title: field.tooltip,
          placement: 'right',
          delay: 300,
        }"
        class="wticon wticon-help-alt co-tooltip"
      />
    </component>
  </div>
</template>

<script>
/**
 * Asset Editor's CustomOverlaysFieldContent
 */
import FieldMedia from './fields/FieldMedia.vue';
import FieldText from 'AssetEditor/functionality/CustomOverlays/fields/FieldText.vue';
import FieldCheckbox from 'AssetEditor/functionality/CustomOverlays/fields/FieldCheckbox.vue';
import FieldColor from 'AssetEditor/functionality/CustomOverlays/fields/FieldColor.vue';
import FieldDropdown from 'AssetEditor/functionality/CustomOverlays/fields/FieldDropdown.vue';
import FieldNumber from 'AssetEditor/functionality/CustomOverlays/fields/FieldNumber.vue';
import FieldSeparator from 'AssetEditor/functionality/CustomOverlays/fields/FieldSeparator.vue';
import FieldSlider from 'AssetEditor/functionality/CustomOverlays/fields/FieldSlider.vue';
import FieldMenuSlider from 'AssetEditor/functionality/CustomOverlays/fields/FieldMenuSlider.vue';
import FieldThumbnailGallery from 'AssetEditor/functionality/CustomOverlays/fields/FieldThumbnailGallery.vue';
import FieldSymbolGallery from 'AssetEditor/functionality/CustomOverlays/fields/FieldSymbolGallery.vue';
import FieldRadio from 'AssetEditor/functionality/CustomOverlays/fields/FieldRadio.vue';
import FieldPositionGrid from 'AssetEditor/functionality/CustomOverlays/fields/FieldPositionGrid.vue';
import FieldCompound from 'AssetEditor/functionality/CustomOverlays/fields/FieldCompound.vue';
import StoryboardHint from 'AssetEditor/functionality/CustomOverlays/fields/StoryboardHint.vue';
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';

export default {
  props: {
    field: { type: Object, required: true },
    stageRect: { type: DOMRect, required: false },
    customOverlay: { type: Object, required: true },
  },

  data() {
    return {
      fieldDataModel: undefined,
      hint: undefined,
    };
  },

  created() {
    this.fieldDataModel = _.clone(this.field?.fieldDataModel);
    this.hint = this.field?.fieldDataModel?.hint;
  },

  components: {
    StoryboardHint,
    FieldText,
    FieldCheckbox,
    FieldColor,
    FieldDropdown,
    FieldNumber,
    FieldSeparator,
    FieldSlider,
    FieldMenuSlider,
    FieldThumbnailGallery,
    FieldSymbolGallery,
    FieldRadio,
    FieldPositionGrid,
    FieldCompound,
    FieldMedia,
  },

  computed: {
    componentName() {
      return 'field-' + (_.kebabCase(this.field.type) || '').toLowerCase();
    },
  },

  methods: {
    onValueChange({ valueChanges, makeDirty = true }) {
      valueChanges = {
        ...valueChanges,
        customOverlayId: this.customOverlay.id,
      };
      this.$emit('change', valueChanges);
    },

    // onEvent({ name, data }) {
    //   // propagate any event to parent
    //   this.$emit(name, data);
    // },
  },

  watch: {},
};
</script>
